import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { NButton, NTooltip } from '@innersource-nn/novoui-react';
import { DatasetCreateFormData, defaultCreateValues } from 'types/Forms';
interface ThirdStepProps {
    importing: boolean;
    setImporting: React.Dispatch<React.SetStateAction<boolean>>;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
    formData: DatasetCreateFormData;
    setFormData: React.Dispatch<React.SetStateAction<DatasetCreateFormData>>;
}

export default function FirstStep({
    importing,
    setImporting,
    setActiveStep,

    setFormData,
}: ThirdStepProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setImporting(event.target.value === 'import');
    };

    function handleClick() {
        if (importing) {
            setFormData({
                ...defaultCreateValues,
                bucketName: '',
                topics: [],
            });
        } else {
            setFormData({
                ...defaultCreateValues,
                datasetStageOptions: 'PROD',
                enableCrawler: true,
            });
        }
        setActiveStep(1);
    }

    return (
        <div>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="create"
                name="radio-buttons-group"
            >
                <FormControlLabel
                    value="create"
                    control={<Radio onChange={handleChange} />}
                    label="Creating new dataset"
                />
                <div className="flex items-center justify-start">
                    <FormControlLabel
                        value="import"
                        control={<Radio onChange={handleChange} />}
                        label="Importing existing one from another AWS account"
                    />
                    <NTooltip
                        content="By linking an existing dataset in another AWS account it allows you to integrate its data with your new dataset. "
                        placement="up"
                    />
                </div>
            </RadioGroup>
            <NButton
                variant="fill"
                square
                className="bg-sea-blue-600 mt-8"
                onClick={handleClick}
            >
                Next step
            </NButton>
        </div>
    );
}
